import React, { useContext, useMemo } from "react";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import { AuthContext } from "../../Context/AuthContext.jsx";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";
import { defineAbilitiesFor } from "../../Utils/PermissionAbility";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";


export const useMenuItems = () => {
  const { user, ability: ctxAbility, isEmployee } = useContext(AuthContext);

  // Use useMemo to prevent unnecessary recalculations of abilities and menu items
  const menuItems = useMemo(() => {
    const ability = ctxAbility ?? defineAbilitiesFor(user || {});

    const items = [
     
       {
        text: "Dashboard",
        icon: <HomeRoundedIcon />,
        path: "/dashboard",
      },

      // {
      //   text: "Positions",
      //   icon: <WorkOutlineIcon />,
      //   path: "/postes",
      // },
      // {
      //   text: "Employees",
      //   icon: <PeopleOutlineIcon />,
      //   path: "/employees",
      // },
      
      ability.can("manage", "Discipline") &&{
        text: "Departments & Units",
        icon: <MenuBookIcon />,
        path: "/admin/disciplines",
      },
      ability.can("manage", "Quiz") &&{
        text: "Quizzes",
        icon: <QuizOutlinedIcon />,
        path: "/admin/quizzes",
      },
      
      ability.can("manage", "Skill") &&{
        text: "Skills",
        icon: <EmojiEventsOutlinedIcon />,
        path: "/admin/skills",
      },
      
     ( ability.can("manage", "Evaluation")  )&&{
        text: "Evaluations",
        icon: <AssignmentOutlinedIcon />,
        path: "/admin/evaluations",
      },
      {
        text: "My Evaluations",
        icon: <AssignmentTurnedInOutlinedIcon />,
        path: "/my-evaluation",
      },
      // ability.can("manage", "Certificate") &&{
      //   text: "Certificates",
      //   icon: <AssignmentTurnedInOutlinedIcon />,
      //   path: "/my-certificates",
      // },
      ability.can("manage", "Evidences") &&{
        text: "Evidences",
        icon: <InsertDriveFileOutlinedIcon />,
        path: "/admin/evidences",
      },
      {
        text: "Administration",
        icon: <AdminPanelSettingsRoundedIcon />,
        path: "/admin",
        children: [
          (ability.can("manage", "User") && !isEmployee) && {
            text: "Employees",
            path: "/admin/users",
          },
          ability.can("manage", "Role") && {
            text: "Roles",
            path: "/admin/roles",
          },
          ability.can("manage", "Poste") && {
            text: "Positions",
            path: "/admin/postes",
          },
          ability.can("manage", "AuditLog") && {
            text: "Audit Logs",
            path: "/admin/audit-logs",
          },
          // ability.can("manage", "RaterType") && {
          //   text: "Rater Types",
          //   path: "/admin/rater-types",
          // },
          
        ].filter(Boolean),
      },
      
    ];

    return items.filter(Boolean);
  }, [ctxAbility, user]);

  return menuItems;
};

export default useMenuItems;
